export default "/auth/img/spike-logo.svg"